
export const Subscribe = () => {
        const handleScroll = () => {
            window.scrollTo({
							top: 0,
							
							behavior: "smooth",
						});
         };
    
	return (
		<div className="relative bg-accent">
			<div className="absolute inset-x-0 bottom-0">
				<svg
					viewBox="0 0 224 12"
					fill="currentColor"
					className="w-full -mb-1 text-white"
					preserveAspectRatio="none">
					<path d="M0,0 C48.8902582,6.27314026 86.2235915,9.40971039 112,9.40971039 C137.776408,9.40971039 175.109742,6.27314026 224,0 L224,12.0441132 L0,12.0441132 L0,0 Z" />
				</svg>
			</div>
			<div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20">
				<div className="relative max-w-2xl sm:mx-auto sm:max-w-xl md:max-w-2xl sm:text-center">
					<h2 className="mb-6 font-sans text-3xl font-bold tracking-tight text-white sm:text-4xl sm:leading-none">
						The quick, brown fox
						<br className="hidden md:block" />
						jumps over a{" "}
						<span className="relative inline-block px-2">
							<div className="absolute inset-0 transform -skew-x-12 bg-teal-accent-400" />
							<span className="relative text-teal-900">lazy dog</span>
						</span>
					</h2>
					<p className="mb-6 text-base text-indigo-100 md:text-lg">
						Sed ut perspiciatis unde omnis iste natus error sit voluptatem
						accusantium doloremque laudantium, totam rem aperiam, eaque ipsa
						quae. explicabo. Sed ut perspiciatis unde omnis.
					</p>
					<form
						action="https://formsubmit.co/et.srabon@gmail.com"
						method="POST"
						className="flex flex-col items-center w-full mb-4 md:flex-row md:px-16">
						<input
							placeholder="Email"
							required
							type="text"
							className="flex-grow w-full h-12 px-4 mb-3 text-black transition duration-200 border-2 border-transparent rounded appearance-none md:mr-2 md:mb-0 bg-deep-purple-900 focus:border-teal-accent-700 focus:outline-none focus:shadow-outline"
						/>
						<button
							type="submit"
							className="inline-flex items-center justify-center w-full h-12 px-6 font-semibold tracking-wide text-teal-900 transition duration-200 rounded shadow-md md:w-auto hover:text-purple-900 bg-teal-400 hover:bg-700 focus:shadow-outline focus:outline-none ">
							Subscribe
						</button>
					</form>
					<p className="max-w-md mb-10 text-xs tracking-wide text-indigo-100 sm:text-sm sm:mx-auto md:mb-16">
						Sed ut perspiciatis unde omnis iste natus error sit voluptatem
						accusantium doloremque.
					</p>
					<div
						onClick={handleScroll}
						aria-label="Scroll up"
						className="flex items-center justify-center w-10 h-10 mx-auto text-white duration-300 transform border border-gray-400 rounded-full hover:text-teal-accent-400 hover:border-teal-accent-400 hover:shadow hover:scale-110">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="24"
							height="24"
							viewBox="0 0 24 24">
							<path d="M0 16.67l2.829 2.83 9.175-9.339 9.167 9.339 2.829-2.83-11.996-12.17z" />
						</svg>
					</div>
				</div>
			</div>
		</div>
	);
};
